import { render, staticRenderFns } from "./PrincipalRegisterV.vue?vue&type=template&id=55210633"
import script from "./PrincipalRegisterV.vue?vue&type=script&lang=js"
export * from "./PrincipalRegisterV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports